import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";
import moment from "moment";

export const addSession = createAsyncThunk('addSession', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'session',
            data: {
                "session_start": data?.values?.sessionStart && moment(data?.values?.sessionStart, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "session_end": data?.values?.sessionEnd && moment(data?.values?.sessionEnd, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "description": data?.values?.description,
                // "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
